import React, { Fragment, useState } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { pushAddToCart } from '../Services/Analytics.service';

const BuyButton = ({
    label,
    articleNumber,
    isProductCardLayout,
}) => {
    const cart = useSelector((state) => state.cart);
    const cartOrderRow = cart?.orderRows?.find(x => x.articleNumber === articleNumber);
    const [addingToCart, setAddingToCart] = useState(false);
    const displayProductCardLayout = isProductCardLayout === 'true' || isProductCardLayout === 'True' || isProductCardLayout === true;
    const dispatch = useDispatch();
    const onClick = async (articleNumber) => {
        if (!addingToCart) {
            try {
                setAddingToCart(true);
                const cart = await addToCartService({ articleNumber });
                dispatch(receive(cart));
                pushAddToCart(articleNumber, cart);
                return true;
            } catch (ex) {
                dispatch(catchError(ex, (error) => loadError(error)));
                return false;
            } finally {
                setAddingToCart(false);
            }
        }
    };

    return (
        <Fragment>
            {!cartOrderRow || !cartOrderRow.singleQuantityOnly ? (
                <Fragment>
                    {displayProductCardLayout ? (
                        <i className="icon-shopping_cart_add" onClick={(e) => onClick(articleNumber)} disabled={addingToCart}></i>
                    ) : (
                        <button className="button" onClick={(e) => onClick(articleNumber)} disabled={addingToCart}>
                            <i className="icon-shopping_cart_add"></i>
                            {label && 
                                <span>{label}</span>
                            }
                        </button>
                    )}
                </Fragment>
            ): (
                <Fragment>
                    {displayProductCardLayout ? (
                        <span>{translate('js.product.alreadyincart')}</span>
                    ) : (
                        <button className="button" disabled>
                            <span>{translate('js.product.alreadyincart')}</span>
                        </button>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export default BuyButton;
